/**
 * DocuSign Digital Referral: "Start free trial" for users who don't have a DocuSign account.
 * Only show when connecting DocuSign for the first time (no existing credentials).
 * Uses DocuSign's hosted script: https://www.docusign.com/scripts/ds-digital-signup.js
 * @see https://developers.docusign.com/partner/digital-referral/
 */

import React from 'react';
import { Typography, Link, Box } from '@material-ui/core';

const DOCUSIGN_REDIRECT_URI = 'https://editor.workload.co:5000/auth/docusign/redirect';
const DOCUSIGN_INTEGRATION_KEY = 'd9be59c8-7962-4b5b-bd42-50ca61a28e54';

/** Returns true if the app is DocuSign (by slug or label). */
export function isDocuSignApp(app, applabel) {
  if (!app && !applabel) return false;
  const a = (app || '').toLowerCase();
  const l = (applabel || '').toLowerCase();
  return a === 'docusign' || l.includes('docusign');
}

/**
 * Renders "Don't have a DocuSign account? Start free trial" and calls
 * DSDigitalSignup.startSignup on click (script loaded in index.html).
 */
export function DocuSignDigitalReferralButton({ className, style }) {
  const handleStartTrial = () => {
    if (typeof window.DSDigitalSignup !== 'undefined' && typeof window.DSDigitalSignup.startSignup === 'function') {
      window.DSDigitalSignup.startSignup({
        partnerIK: DOCUSIGN_INTEGRATION_KEY,
        loginRedirectUri: DOCUSIGN_REDIRECT_URI,
      });
    } else {
      console.warn('DocuSign Digital Signup script not loaded');
    }
  };

  return (
    <Box className={className} style={{ marginTop: 8, ...style }}>
      <Typography variant="body2" color="textSecondary">
        Don't have a DocuSign account?{' '}
        <Link
          component="button"
          variant="body2"
          onClick={handleStartTrial}
          style={{ cursor: 'pointer', color: '#0069ea', fontWeight: 500 }}
        >
          Start free trial
        </Link>
      </Typography>
    </Box>
  );
}
